import script from "./Catalogue.vue?vue&type=script&setup=true&lang=js"
export * from "./Catalogue.vue?vue&type=script&setup=true&lang=js"

import "./Catalogue.vue?vue&type=style&index=0&id=5c9f300e&lang=css"

const __exports__ = script;

export default __exports__